import React, { Component }  from 'react';
import {format} from 'react-string-format';
import Game from "./Game";
import * as ReactDOM from 'react-dom';
import {NavLink} from "react-router-dom";
import {withRouter} from "./withRouter";
import {Col, Container, Row} from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";

class Categories extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: []
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + "/customer/game/categories")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        const { error, isLoaded, items } = this.state;

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded) {
            content = <div>Loading...</div>;
        } else {
            content =
                (<div style={{
                paddingRight: "1%",
                    paddingLeft: "1%",
                    paddingTop: 50,
                    paddingBottom: 50,
                    borderRadius: 8,
                        width: "100%"
                }}>
                    <Carousel variant="dark" slide={true}>
                        {items.map(item => (
                            <Carousel.Item>
                                <img style={{
                                    opacity: 0.6,
                                    maxWidth: "100%",
                                    height: "100%",
                                    maxHeight: "100%",
                                    minHeight: "100%",
                                    borderRadius: 9,
                                    borderColor: "darkgray"
                                }}
                                     src={item.games.length > 0 && item.games[0].game_page ? item.games[0].game_page.background_image_url : "https://wallpaper-house.com/data/out/8/wallpaper2you_287091.png"}
                                     alt=""
                                     width="100%"
                                     height="100%"
                                     align="center"
                                >
                                </img>
                                <Carousel.Caption style={{
                                    zIndex:2,
                                    background: `linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1))`,
                                    bottom:0,
                                    left: 0,
                                    right: 0,
                                }}>
                                    <h1>{item.name}</h1>
                                    {item.downloads_count} {item.downloads_count > 1 ? "downloads total" : "download"}
                                    <br/>
                                    {item.games.length} {item.games.length > 1 ? "apps total" : "app"}
                                    <br/>
                                    <br/>
                                    <NavLink
                                        to={"/categories/" + item.id}
                                        className="btn btn-dark"
                                    >
                                        View
                                    </NavLink>
                                    <br/>
                                    <br/>
                                </Carousel.Caption>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
            );
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}

export default withRouter(Categories);
